<template>
  <v-container class="submit-completed">
    <v-row no-gutters class="mt-7">
      <v-col cols="12" class="order-info">
        <v-card class="text-left default--text h-100" elevation="0">
          <v-card-text>
            <h1
              class="font-weight-bold default--text mb-4"
              v-html="$t('workWithUs.formSubmitted')"
            />
            <div
              class="description mt-2"
              v-html="$t('workWithUs.successDesc')"
            />
          </v-card-text>
          <v-card-actions class="">
            <v-row no-gutters justify="center" align="center">
              <v-col cols="12" sm="auto" class="px-0 px-sm-3 mb-4 mb-sm-0">
                <v-btn
                  x-large
                  depressed
                  class="text-none"
                  :color="order ? 'secondary' : 'primary'"
                  :block="$vuetify.breakpoint.xs"
                  @click="goHome"
                  >{{ $t("workWithUs.goToHome") }}</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<style lang="scss">
.submit-completed {
  h1 {
    font-size: 38px;
    line-height: 1;
  }
  .description {
    font-size: 14px;
    color: #333;
    font-weight: bold;
  }
}
</style>
<script>
import categoryMixins from "~/mixins/category";

export default {
  name: "JobThankYouPage",
  mixins: [categoryMixins],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    goHome() {
      this.$router.push({ name: "Home" });
    }
  },
  mounted() {}
};
</script>
